require('../../styles/index.scss');
require('../../styles/comp/loader.scss');
require('../../styles/ai/ai_image.scss');

const $                         = require('jquery');
const _                         = require('underscore');
const CryptoJS                  = require('crypto-js');
const endpoint                  = require('@readcube/endpoint');
const Extension                 = require('@readcube/extension-detect');
const Importer                  = require('@readcube/extension-importer');
const TrackJS                   = require('../includes/trackjs');
const user                      = require('../user');
const evtout                    = require('../evtout');
const exportHelper              = require('../util/export_helper');
const sidepanel                 = require('../ctrl/sidepanel');
const auth_modal                = require('../modals/auth_modal');
const subscription_modal        = require('../modals/subscription_modal');
const Preview                   = require('../comp/preview');
const aiChat                    = require('./ai_chat');
const uploadPdf                 = require('./upload_pdf');
const userLogin                 = require('./user_login');

require('../comp/user_details');

const emStyle = 'font-weight: bold; color: orange;';
const ST_PREFIX = {
  production: window.reader_data?.st || 'ST_PREFIX_PRODUCTION',
  staging: window.reader_data?.st || 'ST_PREFIX_STAGING'
};

class AiPreview {
  constructor({
    container,
    env,
    doi,
    syncApi,
    uploader,
    test
  }) {
    container ??= document.body;

    this._env = env;
    this._doi = doi;
    this._syncApi = syncApi;
    this._uploader = uploader;
    this._article = {};
    this._test = test;

    this._container = $(`
      <div class="ai-preview">
        <div class="loader-wrap">
          <div class="loader loader-dark"></div>
          <div class="label">Loading Chat with PDF ...</div>
        </div>
        <div class="ai-disabled-modal">
          <div class="modal">
            <h2 class="title">Ask your admin to enable Chat with PDF.</h2>
            <div class="screenshot">
              <div class="ai-image"></div>
            </div>
            <p class="message">Use AI to provide comprehensive summaries, ask detailed questions of full text articles, or find common themes and compare multiple papers.</p>
            <div class="footer">
              <button class="button cancel">Back to Dimensions</button>
              <button class="button primary send-request">Send Request</button>
            </div>
          </div>
        </div>
      </div>
    `);

    this._container.appendTo(container);
    const disabledModal = this._container.find('.ai-disabled-modal');

    disabledModal.find('.cancel').on('click', () => {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        location.href = 'https://app.dimensions.ai';
      }
    });

    disabledModal.find('.send-request').on('click', () => {
      disabledModal.find('.send-request').prop('disabled', true).text('Sending ...');
      sendRequestEmail().then(() => {
        disabledModal.find('.title').text('Request sent!');
        disabledModal.find('.message').text('We have received your request. You can close this window now.');
      }).catch(() => {
        disabledModal.find('.title').text('Request failed!');
        disabledModal.find('.message').text('Sorry, something went wrong. Please try again later.');
      }).finally(() => {
        disabledModal.find('.modal').addClass('done');
        disabledModal.find('.cancel').addClass('primary');
      });
    });

    Promise.all([
      ensureImporter(),
      user.init({ syncApi })
    ]).then(([importer]) => {
      TrackJS.setUser(user.data);

      this._importer = importer;
      this._aiContainer = $(`
        <div class="ai-container ${(user.signedIn ? 'signed-in' : 'signed-out')}">
          <div class="header">Chat with PDF</div>
          <div class="content">
            <div class="chat-wrap">${aiChat}</div>
            <div class="upload-wrap">
              <div class="download-progress">
                <div class="loader loader-dark"></div>
                <div class="label">Checking PDF access ...</div>
              </div>
              ${uploadPdf}
            </div>
            <div class="login-wrap">${userLogin}</div>
          </div>
        </div>
      `).appendTo(this._container);

      this._publisherLink = `https://doi.org/${encodeURIComponent(this._doi)}`;
      this._aiContainer.find('#goto-publisher').on('click', () => {
        window.open(this._publisherLink, '_blank');
      });

      sidepanel.init({ container: this._container });

      this._bindUpload();

      fetchMetadata().then(metadata => {
        this._article = metadata;
        if (!_.isEmpty(metadata)) {
          this._preview = new Preview({ user: user.data, container: this._container, metadata });
        } else {
          this._container.append(`
            <missing-meta>
              <h2>Unfortunately we don't have metadata on this article yet...</br>You can still upload the article PDF in the side panel.</h2>
            </missing-meta>
          `);
        }
      }).finally(() => {
        if (aiDisabledOrg()) {
          $(container).addClass('ai-disabled');
        } else {
          $(container).addClass('ai-enabled');
        }
      });

      this._container.find('#sign-in, #sign-up').on('click', () => {
        auth_modal.login({
          syncApi,
          trackingAction: 'ai_assistant',
          trackingOrigin: 'dimensions'
        });
      });

      user.onSignIn(() => {
        this._aiContainer.removeClass('signed-out').addClass('signed-in');
        if (aiDisabledOrg()) {
          $(container).removeClass('ai-enabled').addClass('ai-disabled');
        } else {
          this._locatePdf();
        }
      });
    });

    function aiDisabledOrg() {
      if (test.ai_disabled) return true;
      return user.organization && !user.aiEnabled;
    }

    function generateMD5Hash(input) {
      return CryptoJS.MD5(input).toString();
    }

    function securityToken() {
      return window.reader_data?.st || generateMD5Hash(`${ST_PREFIX[env]}${doi.toLowerCase()}`);
    }

    function fetchMetadata() {
      return new Promise(resolve => {
        syncApi.reader.abstract({ doi, st: securityToken() })
          .then(resolve)
          .catch(reason => {
            if (reason.error == 'content_missing') {
              evtout.trigger('open-url', [`https://doi.org/${encodeURIComponent(doi)}`]);
            } else {
              resolve({});
            }
          });
      });
    }

    function ensureImporter() {
      const extension = new Extension({ env, minVersion: '4.4.0' });
      return extension.isInstalled().then(installed => {
        if (installed.result) {
          return new Importer({ env, extVersion: installed.version });
        }
        return null;
      });
    }

    function sendRequestEmail() {
      return fetch(`${endpoint.services}/organizations/request_feature`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json'},
        body: JSON.stringify({ feature: 'pdf_ai' })
      }).then(response => {
        if (!response.ok) throw new Error('Request failed');
        return response.json();
      });
    }
  }

  get evtout() {
    return evtout;
  }

  _setStatus(status) {
    this._container.find('.download-progress .label').text(status);
  }

  _locatePdf() {
    this._aiContainer.addClass('pdf-progress');
    this._setStatus('Searching for PDF ...');
    this._syncApi.status.checkExtIds({ extIds: [{ doi: this._doi }], includeFileInfo: true }).then(([items]) => {
      const item = items.find(i => i.primary_file_hash && i.primary_file_type === 'pdf')
      if (item && !this._test.force_upload) {
        this._setItem(item);
        this._setStatus('Loading Chat with PDF ...');
        location.href = `${endpoint.web}/library/${item.collection_id}:${item.id}?ai_assist=1`;
      } else if (this._importer && !this._test.force_upload) {
        this._setStatus('Downloading PDF ...');
        const downloadOptions = {
          skip_cache: this._test.skip_cache,
          skip_proxy: this._test.skip_proxy
        };
        this._importer.downloadDoi(this._doi, downloadOptions).then(detail => {
          console.log('%c download success:', emStyle, detail);
          this._addToLibrary(detail.arrayBuffer);
        }).catch(detail => {
          console.log('%c download failed:', emStyle, detail);
          this._getPublisherLink().then(url => {
            if (url) this._publisherLink = url;
          }).finally(() => {
            this._aiContainer.removeClass('pdf-progress');
          });
        })
      } else {
        this._getPublisherLink().then(url => {
          if (url) this._publisherLink = url;
        }).finally(() => {
          this._aiContainer.removeClass('pdf-progress');
        });
      }
    });
  }

  _getPublisherLink() {
    return this._syncApi.institution.status({ dois: [this._doi] }).then(data => {
      return (data[this._doi]?.pdf_urls || [])
        .filter(item => item.source === 'publisher')
        .sort((a, b) => {
          if (a.direct) return -1;
          if (b.direct) return 1;
          return 0;
        }).at(0)?.url;
    })
  }

  _bindUpload() {
    this._fileElem = this._container.find('#file-elem')[0];
    this._dropArea = this._container.find('#drop-area')[0];
    this._uploadBtn = this._container.find('#upload-pdf')[0];

    this._uploadBtn.addEventListener('click', () => {
      this._fileElem.click();
    });

    const preventDefaults = event => {
      event.preventDefault();
      event.stopPropagation();
    };
    const highlight = event => {
      preventDefaults(event);
      this._dropArea.classList.add('highlight');
    };
    const unhighlight = event => {
      preventDefaults(event);
      this._dropArea.classList.remove('highlight');
    };
    const handleFiles = event => {
      const files = event.target.files;
      handleFile(files[0]);
    };
    const handleDrop = event => {
      event.preventDefault();
      event.stopPropagation();
      unhighlight(event);

      const dt = event.dataTransfer;
      const files = dt.files;
      handleFile(files[0]);
    }
    const handleFile = file => {
      this._fileElem.value = '';
      if (file.type !== 'application/pdf') {
        alert('Please upload a PDF file.');
        return;
      }
      const reader = new FileReader();
      reader.onloadstart = () => {
        this._container.find('.ai-container').addClass('pdf-progress');
        this._setStatus('Reading PDF ...');
      };
      reader.onprogress = event => {
        if (event.lengthComputable) {
          const percentLoaded = Math.round((event.loaded / event.total) * 100);
          this._setStatus(`Reading ... ${percentLoaded}%`);
        }
      };
      reader.onload = event => {
        const arrayBuffer = event.target.result;
        this._addToLibrary(arrayBuffer);
      };
      reader.onerror = event => {
        console.error('Error reading file:', event);
        this._setStatus('Error reading file');
      };
      reader.readAsArrayBuffer(file);
    }

    document.addEventListener('dragenter', preventDefaults, false);
    document.addEventListener('dragover', preventDefaults, false);
    document.addEventListener('dragleave', preventDefaults, false);
    document.addEventListener('drop', preventDefaults, false);

    this._fileElem.addEventListener('change', handleFiles, false);
    this._dropArea.addEventListener('dragenter', highlight, false);
    this._dropArea.addEventListener('dragover', highlight, false);
    this._dropArea.addEventListener('dragleave', unhighlight, false);
    this._dropArea.addEventListener('drop', handleDrop, false);
  }

  _setItem(item) {
    this._item = item;
    this._menu && this._menu.setItem(item);
  }

  _createItem({ extIds, resolveFiles = false }) {
    if (!_.isEmpty(this._item)) return Promise.resolve({ item: this._item });
    return this._uploader.create({
      collectionId: user.data.id, extIds, resolveFiles, skipResolveFiles: !resolveFiles
    });
  }

  _addToLibrary(buffer) {
    const progress = ({ state, loaded, total }) => {
      if (state == 'uploading') {
        const percent = Math.round((loaded / total) * 100);
        this._setStatus(`Uploading ... ${percent}%`);
      } else if (state == 'processing_started') {
        this._setStatus('Processing PDF ...');
      }
    };
    const extIds = { doi: this._doi };
    this._createItem({ extIds }).then(async ({ item }) => {
      this._setItem(this._item);
      let { collection_id: collectionId, id: itemId } = item;
      let fileName = this._article?.meta?.title || exportHelper.getKey(item);
      fileName = (fileName || 'article').replace(/[<>:"\/\\|?*]+/g, '') + '.pdf';
      this._uploader.add({ collectionId, itemId, fileName, buffer,
        skipLicence: true, primary: true, progress })
        .then(() => {
          this._setStatus('Loading Chat with PDF ...');
          location.href = `${endpoint.web}/library/${collectionId}:${itemId}?ai_assist=1`;
        })
        .catch(reason => {
          console.error(reason);
          this._container.find('.ai-container').removeClass('pdf-progress');
          if (reason.error == 'inactive_subscription') {
            subscription_modal.open();
          }
        });
    }).catch(reason => {
      console.error(reason);
      this._container.find('.ai-container').removeClass('pdf-progress');
    });
  }
}

module.exports = AiPreview;
